import { Module } from 'wrapper6'
import '../utils/_event-delegation'

export default class GalleryModal extends Module {
  ready () {
    this.GALLERY_MODAL = document.querySelector('#mtt-gallery-modal')
    const GALLERY_BUTTONS = document.querySelectorAll('[data-gallery-id]')

    this.currentSlide = 0
    this.totalSlides = 0

    if (GALLERY_BUTTONS) {
      const NEXT_ARROW = this.GALLERY_MODAL.querySelector('.slider-arrow--right')
      const PREV_ARROW = this.GALLERY_MODAL.querySelector('.slider-arrow--left')
      const CLOSE_BTN = this.GALLERY_MODAL.querySelector('.mtt-gallery-modal__close')

      CLOSE_BTN.addEventListener('click', () => {
        this.GALLERY_MODAL.classList.remove('mtt-gallery-modal--open')
        this.setCurrentSlideIndex(0)
      })

      window.addEventListener('keyup', event => {
        if (event.which === 27) {
          this.GALLERY_MODAL.classList.remove('mtt-gallery-modal--open')
          this.setCurrentSlideIndex(0)
        }
      })

      NEXT_ARROW.addEventListener('click', () => this.nextSlide())
      PREV_ARROW.addEventListener('click', () => this.prevSlide())

      document.querySelector('body').on('click', '[data-gallery-id]', (event, el) => {
        this.openGalleryModal(el)
      })
    }
  }

  /**
   * Getters / setters
   */

  getGalleryID (target) {
    return target.getAttribute('data-gallery-id')
  }

  getGalleryTitle (target) {
    return target.getAttribute('data-gallery-title')
  }

  getGalleryTagline (target) {
    return target.getAttribute('data-gallery-tagline')
  }

  getGalleryImage (target) {
    return target.getAttribute('data-gallery-first')
  }

  getGalleryCountTotal (target) {
    return target.getAttribute('data-gallery-count')
  }

  getGalleryText (target) {
    return target.getAttribute('data-gallery-text')
  }

  getGalleryImages (target) {
    return JSON.parse(target.getAttribute('data-gallery-images'))
  }

  getFullsizeImage (target) {
    return target.getAttribute('data-full-size')
  }

  setGalleryCount (count) {
    this.GALLERY_MODAL.querySelector('#mtt-gallery-count').innerText = count
  }

  getSlideIndex (target) {
    return target.getAttribute('data-thumb-index')
  }

  getTargetFromIndex (index) {
    return this.GALLERY_MODAL.querySelector(`[data-thumb-index="${index}"]`)
  }

  setCurrentSlideIndex (index) {
    this.currentSlide = index
  }

  /**
   * Handle loading
   */
  startLoading () {
    const CONTAINER = this.GALLERY_MODAL.querySelector('.mtt-gallery-modal__image')
    CONTAINER.classList.add('mtt-gallery-modal__image--loading')
  }

  stopLoading () {
    const CONTAINER = this.GALLERY_MODAL.querySelector('.mtt-gallery-modal__image')
    CONTAINER.classList.remove('mtt-gallery-modal__image--loading')
  }

  /**
   * Change image from thumbnail index
   */
  changeImage (index, targetImage) {
    const NEW_IMG = new Image()
    const IMG = targetImage.querySelector('img')
    const TARGET = this.getTargetFromIndex(index)
    const CONTAINER = this.GALLERY_MODAL.querySelector('.mtt-gallery-modal__image')
    const ACTIVE_THUMB = this.GALLERY_MODAL.querySelector('.mtt-gallery-modal__thumb--active')
    ACTIVE_THUMB.classList.remove('mtt-gallery-modal__thumb--active')
    TARGET.classList.add('mtt-gallery-modal__thumb--active')

    this.setGalleryCount(index + 1)
    this.startLoading()

    NEW_IMG.onload = function () {
      IMG.src = this.src
      CONTAINER.classList.remove('mtt-gallery-modal__image--loading')
    }

    NEW_IMG.src = this.getFullsizeImage(TARGET)
  }

  /**
   * Append content
   */
  appendEmptyThumbnails (target) {
    const COUNT = parseInt(this.getGalleryCountTotal(target))
    const IMAGE_ARRAY = this.getGalleryImages(target)

    this.GALLERY_MODAL.querySelector('.mtt-gallery-modal__thumbnails').innerHTML = ''

    for (let i = 0; i < COUNT; i++) {
      const DIV_ONE = document.createElement('div')
      const DIV_TWO = document.createElement('div')

      DIV_ONE.classList.add('mtt-gallery-modal__thumb')

      if (i === 0) {
        DIV_ONE.classList.add('mtt-gallery-modal__thumb--active')
      }

      DIV_ONE.setAttribute('data-full-size', IMAGE_ARRAY[i].full)
      DIV_ONE.setAttribute('data-thumb-index', i)
      DIV_TWO.classList.add('object-fit')
      DIV_TWO.classList.add('object-fit--fill')

      DIV_ONE.append(DIV_TWO)
      this.GALLERY_MODAL.querySelector('.mtt-gallery-modal__thumbnails').append(DIV_ONE)
    }
  }

  appendMainImage (target) {
    const IMG_TAG = document.createElement('img')
    const NEW_IMG = new Image()
    const GALLERY_MODAL = this.GALLERY_MODAL
    const CONTAINER = this.GALLERY_MODAL.querySelector('.mtt-gallery-modal__image')
    const MAIN_IMG = GALLERY_MODAL.querySelector('.mtt-gallery-modal__image .object-fit')
    MAIN_IMG.innerHTML = ''

    this.startLoading()

    NEW_IMG.onload = function () {
      IMG_TAG.src = this.src
      MAIN_IMG.append(IMG_TAG)
      CONTAINER.classList.remove('mtt-gallery-modal__image--loading')
    }

    NEW_IMG.src = this.getGalleryImage(target)
  }

  appendThumbnails (target) {
    const IMAGES = this.getGalleryImages(target)

    for (let i = 0; i < IMAGES.length; i++) {
      const IMAGE_ARRAY = IMAGES[i]

      const IMG_TAG = document.createElement('img')
      const NEW_IMG = new Image()
      const THUMBNAIL_CONTAINERS = this.GALLERY_MODAL.querySelectorAll('.mtt-gallery-modal__thumb .object-fit')

      NEW_IMG.onload = function () {
        IMG_TAG.src = this.src
        THUMBNAIL_CONTAINERS[i].append(IMG_TAG)
      }

      NEW_IMG.src = IMAGE_ARRAY.thumbnail
    }
  }

  updateGalleryContent (target) {
    this.GALLERY_MODAL.querySelector('.mtt-tagline').innerText = this.getGalleryTagline(target)
    this.GALLERY_MODAL.querySelector('.heading').innerText = this.getGalleryTitle(target)
    this.GALLERY_MODAL.querySelector('.mtt-gallery-modal__text').innerHTML = this.getGalleryText(target)
    this.GALLERY_MODAL.querySelector('#mtt-gallery-count-total').innerText = this.getGalleryCountTotal(target)
    this.appendMainImage(target)
    this.appendEmptyThumbnails(target)
    this.setGalleryCount('1')
    this.currentSlide = 0
    this.totalSlides = this.getGalleryCountTotal(target)
  }

  openGalleryModal (target) {
    this.GALLERY_MODAL.classList.add('mtt-gallery-modal--open')
    this.updateGalleryContent(target)
    this.appendThumbnails(target)
    this.addEventListeners()
  }

  /**
   * Slider control
   */
  nextSlide () {
    let slideIndex = 0

    if (this.currentSlide < (this.totalSlides - 1)) {
      slideIndex = this.currentSlide += 1
    } else {
      this.currentSlide = 0
    }

    this.changeImage(slideIndex, this.GALLERY_MODAL.querySelector('.mtt-gallery-modal__image'))
  }

  prevSlide () {
    let slideIndex = 0

    if (this.currentSlide === 0) {
      this.currentSlide = this.totalSlides - 1
      slideIndex = this.currentSlide
    } else {
      slideIndex = this.currentSlide -= 1
    }

    this.changeImage(slideIndex, this.GALLERY_MODAL.querySelector('.mtt-gallery-modal__image'))
  }

  addEventListeners () {
    const THUMBS = this.GALLERY_MODAL.querySelectorAll('.mtt-gallery-modal__thumb')
    const MAIN_IMAGE = this.GALLERY_MODAL.querySelector('.mtt-gallery-modal__image')

    for (let i = 0; i < THUMBS.length; i++) {
      const THUMB = THUMBS[i]

      THUMB.addEventListener('click', event => {
        const CLICKED_THUMB = event.currentTarget
        const SLIDE_INDEX = parseInt(this.getSlideIndex(CLICKED_THUMB))

        this.changeImage(SLIDE_INDEX, MAIN_IMAGE)
        this.setCurrentSlideIndex(SLIDE_INDEX)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./resources/js/modules/_gallery-modal.js